export const resultsFiltersReducerKey = 'ResultsFilters';

export const setOpenFiltersType = 'SET_OPEN_FILTERS_TYPE';
export const setAppliedFilterSummaryType = 'SET_APPLIED_FILTER_SUMMARY_TYPE';

export const ascending = 'ascending';
export const descending = 'descending';
export const occurrence = 'occurrence';
export const byValue = 'byValue';
export const preferredSuppliersFilterId = 'SUPP.PREF_SNAME';
export const preferredCurrencyFilterId = 'PROD.PREF_CURRENCY';
export const preferredShipmentCountryFilterId = 'PROD.PREF_LOC';
export const preferredShippingTimeFilterId = 'PROD.PREF_TIER';
export const preferenceFilterIds = [
  preferredSuppliersFilterId,
  preferredCurrencyFilterId,
  preferredShipmentCountryFilterId,
  preferredShippingTimeFilterId,
];
export const commercialSuppliersFilterId = 'SUPP.SNAME';
export const shipmentTimeFilterId = 'PROD.SHIPTIME';
export const shippingTimeFilterId = 'PROD.TIER';
export const currencyFilterId = 'PROD.CURRENCY';
export const shipmentCountryFilterId = 'PROD.LOC';

// Display order of the commercial-substances filter rail on RCS databases.
// Each entry is matched against a filter's backend id (carried on its `value`) for filters that have a
// stable id, or against its display `title` (case-insensitive) for filters that only carry a label.
// Filters not listed here keep their original relative order and are appended after the listed ones.
export const commercialSubstancesFilterOrder = [
  commercialSuppliersFilterId, // SUPP.SNAME
  'purity',
  'package size',
  currencyFilterId, // PROD.CURRENCY
  'price',
  shippingTimeFilterId, // PROD.TIER
  shipmentCountryFilterId, // PROD.LOC
  'supplier geolocation',
  'availability',
  'usage classification',
  'molecular weight',
  'number of fragments',
];

export const DOCUMENT_PROCESSING_TYPES = {
  automatic: {
    label: 'Automated',
    icon: 'automated-icon',
  },
  manual: {
    label: 'Manual',
    icon: 'manual-icon',
  },
  getType: (value) => {
    if (!value) {
      return null;
    }
    const key = Object.keys(DOCUMENT_PROCESSING_TYPES).find((type) => value.indexOf(type) >= 0);
    return key ? DOCUMENT_PROCESSING_TYPES[key] : null;
  },
};

/**
 * Additional custom filter by filter ID config if needed. Can override filter value title, additional icon and filter header tooltip
 * @type {{'filterId': {optionIcon: (function(*=): *), tooltip: string, optionTitle: (function(*=): *)}}}
 */
export const filtersCustomConfigMap = {};

export const AUTHOR_NAME_FILTER_ID = 'CIT.AU';
export const AUTHORS_OF_SCI_DOC_FILTER_ID = 'AUTHOR.NAME';
export const AFFILIATIONS_FILTER_ID = 'AUTHOR.AFFILPDISPNAME';
export const INVENTORS_OF_PATENTS_FILTER_ID = 'PBIB.INV';
